import React, { useEffect, useRef, useState } from "react";
// import { Link } from 'react-router-dom'
// import AddIcon from '@mui/icons-material/Add';
import Modal from 'react-modal';
import CloseIcon from '@mui/icons-material/Close';
// import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { useGlobalContext } from "../../../Context/GlobalContext";
import Cookies from "js-cookie";

const VerifyAadhaar = () => {

    const { baseUrl, selectedStaff, openToast } = useGlobalContext();
    const [isLoading, setIsLoading] = useState(false);
    const [aadhaar1, setAadhaar1] = useState({
        number: selectedStaff?.staffDetails?.staff_bg_verification?.aadhaar_number,
        status: selectedStaff?.staffDetails?.staff_bg_verification?.aadhaar_verification_status,
        verificationFile: selectedStaff?.staffDetails?.staff_bg_verification?.aadhaar_file
    });

    const [aadhaar2, setAadhaar2] = useState({ verificationFile: selectedStaff?.staffDetails?.staff_bg_verification?.aadhaar_file || null });

    async function submitAadhar() {
        setIsLoading(true);
        // if (!aadhaar1?.number || !aadhaar1?.verificationFile) {
        //     openToast("Provide either aadhaar number or upload file", "warning");
        //     return;
        // }

        console.log(aadhaar1);
        // Create a new FormData instance
        const newFormData = new FormData();

        // Append Aadhaar number and file to FormData


        newFormData.append("aadhaar_number", aadhaar1?.number || "");
        newFormData.append("verificationFile", aadhaar1?.verificationFile);


        try {
            const response = await fetch(
                `${baseUrl}bg-verification/${selectedStaff.staffDetails.id}/verify/aadhaar`,
                {
                    method: "PUT",
                    headers: {
                        Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
                    },
                    body: newFormData,
                    // Headers are not needed for FormData; fetch will automatically set 'Content-Type' as 'multipart/form-data'
                }
            );

            console.log("Response from backend:", response);

            if (response.ok) {  // Changed to response.ok to handle all 2xx responses
                const result = await response.json();
                console.log("Response data:", result);

                // Update Aadhaar state with the new data received from the backend
                setAadhaar1({
                    ...aadhaar1,
                    number: result?.data?.aadhaar_number,
                    status: result?.data?.aadhaar_verification_status ,
                    verificationFile: result?.data?.aadhaar_file
                });

                // Show success toast and close modal
                openToast("Aadhaar successfully updated or created", "success");
                closeModal2();
            } else {
                // Show error toast if response status is not 2xx
                openToast("An error occurred while adding or updating Aadhaar", "error");
            }
        } catch (error) {
            console.error("Error submitting Aadhaar:", error);
            openToast("An error occurred while adding or updating Aadhaar", "error");
        } finally {
            setIsLoading(false);
        }
    }

    let subtitle;

    const [modalIsOpen2, setIsOpen2] = React.useState(false);
    function openModal2() {
        setIsOpen2(true);
    }
    function afterOpenModal2() {
        // references are now sync'd and can be accessed.
        subtitle.style.color = '#000';

    }

    function closeModal2() {
        setIsOpen2(false);
    }

    // const handleFileChange = (event) => {
    //     const file = event.target.files[0]; // Get the selected file
    //     if (file) {
    //         const fileURL = URL.createObjectURL(file); // Generate a temporary URL
    //         setAadhaar({ ...aadhaar, verificationFile: fileURL }); // Store the URL
    //     }
    // };
    const fileInputRef = useRef(null);

    // Function to handle button click and open file input dialog
    const handleUploadClick = () => {
        fileInputRef.current.click(); // Trigger click on input type="file"
    };

    // Function to handle file selection
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setAadhaar1({ ...aadhaar1, verificationFile: file });
        if (file) {
            const fileURL = URL.createObjectURL(file); // Create a blob URL for the file
            setAadhaar2({ ...aadhaar2, verificationFile: fileURL }); // Update state with the file URL
        }
    };



    return (
        <div className='relative flex flex-col xl:pt-[30px] w-full'>
            <div className='top-0 flex justify-between items-center bg-white pr-0 xl:pr-[0px] pb-[10px] pl-[0] w-[100%]'>
                <h3 className='font-medium text-[13px] md:text-[15px]'>Aadhaar Verification</h3>
                <button className={'second-btn ' + (isLoading && 'opacity-50 cursor-not-allowed animate-pulse')} onClick={submitAadhar}>
                    Update Aadhaar
                </button>
            </div>

            <div className='flex justify-between items-center border-1 bg-[#fff] shadow-cs mb-3 p-4 border rounded-lg' >
                <h4 className='font-light'>Aadhaar</h4>
                <p className='font-light'>{aadhaar1?.number}</p>
                <button className='second-btn' onClick={openModal2}  >
                    Add
                </button>

            </div>


            <div className='flex justify-between items-center border-1 bg-[#fff] shadow-cs mb-3 p-4 border rounded-lg' >
                <h4 className='font-light'>Verification Status
                </h4>
                <p className='font-light'>{aadhaar1?.status}</p>
            </div>


            <div className="flex justify-between items-center border-1 bg-[#fff] shadow-cs mb-3 p-4 border rounded-lg">
                <h4 className="font-light">Proofs</h4>
                <input
                    type="file"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                />
                <div className="flex justify-center items-center bg-gray-100 border rounded-md w-[100px] h-[50px] image-container">
                    {aadhaar2?.verificationFile ? (
                        typeof aadhaar2.verificationFile === "string" ? (
                            <img
                                src={aadhaar2.verificationFile}
                                alt="Selected File"
                                className="rounded-md max-w-full max-h-full"
                            />
                        ) : (
                            <span className="text-gray-500 text-sm">Invalid file</span>
                        )
                    ) : (
                        <span className="text-gray-500 text-sm">No file</span>
                    )}
                </div>
                <button className="second-btn" onClick={handleUploadClick}>
                    Upload
                </button>
            </div>

            <Modal
                isOpen={modalIsOpen2}
                onAfterOpen={afterOpenModal2}
                onRequestClose={closeModal2}
                // style={customStyles}
                contentLabel="Example Modal"
                className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow-cs shadow-md p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"

            >
                <h2 ref={(_subtitle) => (subtitle = _subtitle)} className='p-3 border-b-1 text-[13px] xl:text-[15px]'>Add Aadhaar</h2>
                <button onClick={closeModal2} className='top-[3px] right-[5px] absolute bg-[#27004a] rounded-full font-semibold'><CloseIcon className='text-white' /></button>
                <div className=''>
                    <div className='p-[10px] border border-t field-modal modal-field'>
                        <label className='font-medium text-[13px] xl:text-[14px]'>Aadhaar
                        </label><br />
                        <input type='text' placeholder="0000-0000-0000" className='border-1 mt-1 mb-[10px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none newsetup3' value={aadhaar1?.number} onChange={(e) => setAadhaar1({ ...aadhaar1, number: e.target.value })} /><br />
                    </div>
                    <div className='flex justify-end gap-[10px] pt-3 pr-[10px] pb-3 border-t'>
                        <button className='first-btn' onClick={closeModal2}>Cancel</button>
                        <button className='second-btn' onClick={closeModal2}>Save </button>
                    </div>
                </div>
            </Modal>

        </div>
    )
}

export default VerifyAadhaar